module.exports = __webpack_public_path__ + "img/png.402ac11e.png";